{
	"imprintTitle": "Αποτύπωμα",
	"termsAndConditionsTitle": "Όροι και Προϋποθέσεις",
	"privacyPolicyTitle": "Πολιτική Απορρήτου",
	"openSourceAttributionTitle": "Αναφορά ανοιχτού κώδικα"
}
